import { useMutation, useQueryClient } from '@tanstack/react-query';

import { deactivateAchievement } from '~/services/AgentHub/AgentService';

import { achievementQueryKeys } from './useListAchievements';

interface UseDeactivateAchievementOptions {
  onSuccess?: () => void;
  onError?: (error: Error) => void;
}

export function useDeactivateAchievement(options: UseDeactivateAchievementOptions = {}) {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: async (achievementId: string) => {
      return await deactivateAchievement(achievementId);
    },
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: achievementQueryKeys.all });
      options.onSuccess?.();
    },
    onError: (error: Error) => {
      options.onError?.(error);
    },
  });
}
